module.exports = require('./lightbox-react').default;



// WEBPACK FOOTER //
// ./src/index.js